import { useEffect, useCallback, useState, useMemo, useRef } from 'react'

import _ from 'lodash'

import { Settings } from 'helpers/settings-enum'
import { settingsMenuSelector } from 'slices/ui'


import { useField, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { useSelector } from 'react-redux'
import { RootState } from 'slices'
import { useAppDispatch } from 'store'

import client from 'api'



import { BaseLookup } from '../base-lookup'
import { useIxLookupContext } from 'contexts/lookup-context'
import { ixStringToInt } from 'helpers/string-utils'
import { useLookupFetch, LookupFetchConfig, useFiltersList } from 'hooks'
import { fetchLookupData, lookupDataSelector } from 'slices/lookup-data-slice'
import {
    useContextSelfCallback,
    useSelectionChangedCallback,
    useInputChangedCallback,
    useIxGenLookupArray,
} from 'hooks'

import * as IxERechnungArtModule from 'enums/e-rechnung-art-enum.gen'
import { useIxIconCellRender } from 'hooks/use-icon-cell-render'

const _valueExpr = 'NO'

const inputRe = [
/^(?<NO>\w+)$/,
]

const inputFormat = (x: any) => {
    return x ? `${x.NO}` : ''
}

const shouldUpdateConfig: any[] = []

const fetchConfig: LookupFetchConfig = {
    url: '/api/ixweb/krestm/',
    fields: 'HDR_ID,HDR_H1_USERID,HDR_H1_TIMESTAMP,HDR_H2_USERID,HDR_H2_TIMESTAMP,HDR_VERSION,NO,TYP,ANS_1,ANS_2,ANS_3,ANS_4,ANS_5,TEL_1,TEL_2,TEL_3,TEL_4,PAR_1,PAR_2,BANK,BLZ,KTO,NOTI_1,NOTI_2,NOTI_3,ZZIEL_1_TAGE,ZZIEL_1_SKONTO,ZZIEL_2_TAGE,ZZIEL_2_SKONTO,ZZIEL_3_TAGE,ZZIEL_3_SKONTO,UMSATZ_1,UMSATZ_2,UMSATZ_3,UMSATZ_4,UMSATZ_5,GEWERK,OKDN,EZ,SOLL_1,SOLL_2,SOLL_3,SOLL_4,SOLL_5,HAB_1,HAB_2,HAB_3,HAB_4,HAB_5,ZVAUS,FORD,VERB,MAHNST,OBJGROUP,LKZ,WAEHRUNGSCODE,SOLLVORUMS,HABVORUMS,WRNGUMSDAT,OLDWAEHRUNGSCODE,WRNGUMSSLOT,VERIFYWRNGCODE,VERIFYWRNGOLDCODE,UMSATZVORUMS,ZIELBANKNR,BUSPERRE,EMAIL,FINANZAMT,STEUERNR,FREISTZEITR_1,FREISTZEITR_2,EXTADRREF,NCS_PARTNER_ID,USTID,IBAN,SWIFT,LANDLKZID,IRISNO,FREISTBES,FREISTBESDATUM,GEWERKINFO,AUFTRAGSSPERRE,OLDFLG,FREMDSYSTEMNR,INTERCOMPANYFIBUID,CASHPOOLZINSTABID,CASHPOOLKRESTMID,CASHPOOLVERRKONTO,MAHNNOTIZ,MAHNSPERRE,N13BOPTION,KURZNOTIZ,PARTNERROLEID,PARTNERROLE2ID,ANR_1,ANR_2,OKDNPFLICHT,RNGEMPFID,FREMDVWLIZMAX,FREMDVWLIZWARN,BUNDESLANDID,FSBNR,ERECHNUNGTYP,ERECHNUNMAIL,KONTOINHABER,ZVAUSID',
    allowedFilters: ['no'],
}

const castToType = (val: any) => {
    return val
}

export const IxSupplierLookupFieldsConf = {
    'HDR_ID': { type: 'number' },
    'HDR_H1_USERID': { type: 'number' },
    'HDR_H1_TIMESTAMP': { type: 'date' },
    'HDR_H2_USERID': { type: 'number' },
    'HDR_H2_TIMESTAMP': { type: 'date' },
    'HDR_VERSION': { type: 'number' },
    'NO': { type: 'string' },
    'TYP': { type: 'string' },
    'ANS_1': { type: 'string' },
    'ANS_2': { type: 'string' },
    'ANS_3': { type: 'string' },
    'ANS_4': { type: 'string' },
    'ANS_5': { type: 'string' },
    'TEL_1': { type: 'string' },
    'TEL_2': { type: 'string' },
    'TEL_3': { type: 'string' },
    'TEL_4': { type: 'string' },
    'PAR_1': { type: 'string' },
    'PAR_2': { type: 'string' },
    'BANK': { type: 'string' },
    'BLZ': { type: 'string' },
    'KTO': { type: 'string' },
    'NOTI_1': { type: 'string' },
    'NOTI_2': { type: 'string' },
    'NOTI_3': { type: 'string' },
    'ZZIEL_1_TAGE': { type: 'string' },
    'ZZIEL_1_SKONTO': { type: 'string' },
    'ZZIEL_2_TAGE': { type: 'string' },
    'ZZIEL_2_SKONTO': { type: 'string' },
    'ZZIEL_3_TAGE': { type: 'string' },
    'ZZIEL_3_SKONTO': { type: 'string' },
    'UMSATZ_1': { type: 'number.2' },
    'UMSATZ_2': { type: 'number.2' },
    'UMSATZ_3': { type: 'number.2' },
    'UMSATZ_4': { type: 'number.2' },
    'UMSATZ_5': { type: 'number.2' },
    'GEWERK': { type: 'string' },
    'OKDN': { type: 'string' },
    'EZ': { type: 'string' },
    'SOLL_1': { type: 'number.2' },
    'SOLL_2': { type: 'number.2' },
    'SOLL_3': { type: 'number.2' },
    'SOLL_4': { type: 'number.2' },
    'SOLL_5': { type: 'number.2' },
    'HAB_1': { type: 'number.2' },
    'HAB_2': { type: 'number.2' },
    'HAB_3': { type: 'number.2' },
    'HAB_4': { type: 'number.2' },
    'HAB_5': { type: 'number.2' },
    'ZVAUS': { type: 'string' },
    'FORD': { type: 'string' },
    'VERB': { type: 'string' },
    'MAHNST': { type: 'number' },
    'OBJGROUP': { type: 'string' },
    'LKZ': { type: 'string' },
    'WAEHRUNGSCODE': { type: 'number' },
    'SOLLVORUMS': { type: 'number.2' },
    'HABVORUMS': { type: 'number.2' },
    'WRNGUMSDAT': { type: 'number' },
    'OLDWAEHRUNGSCODE': { type: 'number' },
    'WRNGUMSSLOT': { type: 'number' },
    'VERIFYWRNGCODE': { type: 'number' },
    'VERIFYWRNGOLDCODE': { type: 'number' },
    'UMSATZVORUMS': { type: 'number.2' },
    'ZIELBANKNR': { type: 'string' },
    'BUSPERRE': { type: 'string' },
    'EMAIL': { type: 'string' },
    'FINANZAMT': { type: 'number' },
    'STEUERNR': { type: 'string' },
    'FREISTZEITR_1': { type: 'number' },
    'FREISTZEITR_2': { type: 'number' },
    'EXTADRREF': { type: 'string' },
    'NCS_PARTNER_ID': { type: 'number' },
    'USTID': { type: 'string' },
    'IBAN': { type: 'string' },
    'SWIFT': { type: 'string' },
    'LANDLKZID': { type: 'number' },
    'IRISNO': { type: 'string' },
    'FREISTBES': { type: 'number' },
    'FREISTBESDATUM': { type: 'date' },
    'GEWERKINFO': { type: 'string' },
    'AUFTRAGSSPERRE': { type: 'number' },
    'OLDFLG': { type: 'number' },
    'FREMDSYSTEMNR': { type: 'string' },
    'INTERCOMPANYFIBUID': { type: 'number' },
    'CASHPOOLZINSTABID': { type: 'number' },
    'CASHPOOLKRESTMID': { type: 'number' },
    'CASHPOOLVERRKONTO': { type: 'string' },
    'MAHNNOTIZ': { type: 'string' },
    'MAHNSPERRE': { type: 'number' },
    'N13BOPTION': { type: 'number' },
    'KURZNOTIZ': { type: 'string' },
    'PARTNERROLEID': { type: 'number' },
    'PARTNERROLE2ID': { type: 'number' },
    'ANR_1': { type: 'string' },
    'ANR_2': { type: 'string' },
    'OKDNPFLICHT': { type: 'number' },
    'RNGEMPFID': { type: 'number' },
    'FREMDVWLIZMAX': { type: 'number' },
    'FREMDVWLIZWARN': { type: 'number' },
    'BUNDESLANDID': { type: 'number' },
    'FSBNR': { type: 'string' },
    'ERECHNUNGTYP': { type: 'number' },
    'ERECHNUNMAIL': { type: 'string' },
    'KONTOINHABER': { type: 'string' },
    'ZVAUSID': { type: 'number' },
}

export const useIxSupplierLookupData = (
    active=true,
    valueExpr: string = _valueExpr,
    _?: any,
) => {
    const dispatch = useAppDispatch()
    const params = useMemo<any>(() => {
        let params = {}
        return params
    }, [])
    const { data } = useSelector((state: RootState) => lookupDataSelector(
        state,
        'IxSupplierLookup',
        params
    ))
    const [lookupMap, setLookupMap] = useState<any>(null)

    const {value: number} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupNumberFormat))
    const {value: separator} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupSeparatorFormat))
    const {value: info} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupInfoFormat))

    const loadData = useCallback((force=false) => {
        dispatch(fetchLookupData({ lookupName: 'IxSupplierLookup', url: fetchConfig.url, params, force }))
    }, [dispatch, params])

    useEffect(() => {
        loadData()
    }, [loadData])

    const format = useCallback((x: any) => {
        return `${number.prefix}${x.NO !== null && x.NO !== undefined ? x.NO : ''}${number.suffix}${separator.value}${info.prefix} ${x.ANS_1 !== null && x.ANS_1 !== undefined ? `${x.ANS_1} ` : ''}${x.ANS_2 !== null && x.ANS_2 !== undefined ? `${x.ANS_2} ` : ''}${x.ANS_3 !== null && x.ANS_3 !== undefined ? x.ANS_3 : ''}${info.suffix}`
    }, [number, separator, info])

    useEffect(() => {
        if (data) {
            const typesMap = data.map((t: any) => ({
                id: t[valueExpr],
                value: format(t),
            }))
            setLookupMap(typesMap)
        }
    }, [data, format, valueExpr])

    const getFormat = useCallback((no: any, ) => {
        if (lookupMap) {
            const item = lookupMap.find((x: any) => {
                return x.id == no  // eslint-disable-line eqeqeq
            })
            return item ? item.value : ''
        }
        return ''
    }, [lookupMap])

    const getLookupValue = useCallback((val: any) => {
        
        if (data) {
            const item = data.find((x: any) => {
                return x[valueExpr] == val  // eslint-disable-line eqeqeq
            })

            return item
        }
        return undefined
    }, [data, valueExpr])

    return {
        data,
        format,
        getFormat,
        getLookupValue,
        loadData,
        lookupMap,
    }
}


export type IIxSupplierLookupProps = {
    name: string,  // field name in the formik form, would also be used in the lookup context
    readOnly: boolean,
    active?: boolean,
    label?: string,
    onLoadingChanged?: (name: string, isLoading: boolean) => void,
    selectionMode?: 'single' | 'multi' | 'multicsv' | 'range' | 'singlerange',
    getFirstCtxValue?: boolean,
    visible?: boolean,
    openDropdown?: boolean,
    onInfoChange?: any,
    valueExpr?: string,
    updateField?: any,
}

export const IxSupplierLookup = ({
    name,
    readOnly,
    active=true,
    label,
    onLoadingChanged,
    selectionMode='single',
    getFirstCtxValue=false,
    visible=true,
    openDropdown=false,
    onInfoChange,
    valueExpr=_valueExpr,
    updateField,
}: IIxSupplierLookupProps) => {
    const { t } = useTranslation()

    const baseLookup = useRef<any>(null)
    const [field] = useField(name)

    const [firstRender, setFirstRender] = useState(true)
    const lastFormikValue = useRef(null)

    const {value: number} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupNumberFormat))
    const {value: separator} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupSeparatorFormat))
    const {value: info} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupInfoFormat))

    const [value, setValue] = useState<any>(null)
    const [callbacks, setCallbacks] = useState<{[k: string]: (v: any, force?: boolean) => void}>({})
    const { data, load, loadItem, loading, reset, setData, dataLoaded, lastParams } = useLookupFetch(fetchConfig)  // eslint-disable-line @typescript-eslint/no-unused-vars

    const { setFieldValue: setLookupFieldValue, getFieldValue: getLookupFieldValue,
        getFieldReadOnly: getLookupFieldReadOnly } = useIxLookupContext()


    const contextFilters = useFiltersList()
    const setContextFilter = contextFilters.setFilter
    const { setFieldValue } = useFormikContext()

    const openLookup = useCallback((searchText: string | undefined, rangeStart?: string) => {
        if (!dataLoaded) { load(contextFilters.state).then(() => baseLookup.current?.open(searchText, rangeStart)) }
        else { baseLookup.current?.open(searchText, rangeStart) }
    }, [dataLoaded, load, contextFilters.state])


    // formating function to modify displayed value
    const format = useCallback((x: any) => {
        if (x) {
            return `${number.prefix}${x.NO !== null && x.NO !== undefined ? x.NO : ''}${number.suffix}${separator.value}${info.prefix} ${x.ANS_1 !== null && x.ANS_1 !== undefined ? `${x.ANS_1} ` : ''}${x.ANS_2 !== null && x.ANS_2 !== undefined ? `${x.ANS_2} ` : ''}${x.ANS_3 !== null && x.ANS_3 !== undefined ? x.ANS_3 : ''}${info.suffix}`
        } else {
            return field.value ? `${number.prefix}${field.value || ''}${number.suffix}` : ''
        }
    }, [field.value, number, separator, info])

    const rangeFormat = useCallback((x: any, full: boolean) => {
        if (x) {
            if (full) {
                return `${number.prefix}${x.NO !== null && x.NO !== undefined ? x.NO.replace('-', '/') : ''}${number.suffix}`
            } else {
                return `${x.NO ? x.NO.replace('-', '/') : ''}`
            }
        } else {
            return `${field.value ? field.value.replace('-', '/') : ''}`
        }
    }, [field.value, number])

    const handleSelectionChanged = useSelectionChangedCallback({
        value,
        setValue,
        selectionMode,
        displayExpr: rangeFormat
    })

    const handleInputChanged = useInputChangedCallback({
        inputRe,
        getLookupFieldReadOnly,
        loadItem,
        handleSelectionChanged,
        globalFilters: contextFilters.state,
        openLookup,
        selectionMode,
        setValue,
    })

    // call onLoadingChanged callback if available
    useEffect(() => {
        onLoadingChanged && onLoadingChanged(name, loading)
    }, [onLoadingChanged, loading, name])

    useEffect(() => {
        if (value && typeof value !== 'string' && updateField?.name && updateField?.column) {
            Array.isArray(value)
                ? setFieldValue(updateField.name, `${value.map((x: any) => x[updateField.column]).join(',')}`, true)
                : setFieldValue(updateField.name, value[updateField.column], true)
        }

    },[setFieldValue, updateField?.name, updateField?.column, value])

    // if formik value changes update lookup
    useEffect(() => {
        if (firstRender || !active || _.isEqual(field.value, lastFormikValue.current)) { return }

        if (selectionMode === 'range') {
            lastFormikValue.current = field.value
            setValue(field.value)
        } else {
            lastFormikValue.current = field.value

            if (_.isNil(value) && _.isNil(field.value)) { return }
            else if (_.isNil(field.value)) { handleSelectionChanged(null); return }

            let field_value = field.value;
            if (selectionMode === 'multicsv' && typeof(field.value) === 'string') {
                field_value = field.value.split(',').map((x: string) => ixStringToInt(x))
            }

            if (Array.isArray(field_value)) {
                if (_.isNil(value) || !_.isEqual(value.map((x: any) => x[valueExpr]), field_value)) {
                    if (field_value) {
                        load(contextFilters.state)
                            .then((data: any) => handleSelectionChanged(data.filter((x: any) => field_value.includes(x[valueExpr]))))
                            .catch(() => {})
                    } else {
                        handleSelectionChanged(field_value)
                    }
                }
            } else {
                if (_.isNil(value) || value[valueExpr] !== field_value) {
                    if (field_value) {
                        loadItem(contextFilters.state, { [valueExpr]: field_value })
                            .then((data: any) => handleSelectionChanged(data))
                            .catch(() => {})
                    } else {
                        handleSelectionChanged(field_value)
                    }
                }
            }
        }
    }, [field.value, active, firstRender, contextFilters.state, load,
        loadItem, handleSelectionChanged, selectionMode, value,
        valueExpr])

    useEffect(() => {
        if (readOnly && field.value && selectionMode !== 'range' && !_.isEqual(field.value, lastFormikValue.current)) {
            if (value !== null) { return }

            lastFormikValue.current = field.value

            if (selectionMode === 'single') {
                loadItem(contextFilters.state, { [valueExpr]: field.value })
                    .then(res => handleSelectionChanged(res))
                    .catch(() => {})
            } else {
                load(contextFilters.state)
                    .then((data: any) => handleSelectionChanged(data.filter((x: any) => field.value.includes(x[valueExpr]))))
                    .catch(() => {})
            }
        }
    }, [loadItem, load, field.value, value, contextFilters.state, readOnly,
        handleSelectionChanged, selectionMode, valueExpr])

    useEffect(() => {
        if (!firstRender) { return }

        const val = getLookupFieldValue(name)
        if (selectionMode === 'multi') {
            if (val && Array.isArray(val)) {
                const vIds = val.map((v: any) => v && typeof(v) === 'object' ? v[valueExpr] : null).filter((v: any) => v)
                if (vIds.length === val.length && _.isEqual(vIds, field.value)) {
                    setValue(val)
                    setData(val)
                    lastFormikValue.current = field.value
                }
            }
        } else if (selectionMode === 'multicsv') {
            if (val && Array.isArray(val)) {
                const vIds = val.map((v: any) => v && typeof(v) === 'object' ? v[valueExpr] : null).filter((v: any) => v).join(', ')
                if (_.isEqual(vIds, field.value)) {
                    setValue(val)
                    setData(val)
                    lastFormikValue.current = field.value
                }
            }
        } else {
            if (selectionMode === 'single' && val && typeof(val) === 'object' && field.value === val[valueExpr]) {
                setValue(val)
                setData([val])
                lastFormikValue.current = field.value
            } else if (selectionMode === 'range' && val) {
                setValue(val)
            }
        }

        if (field.value === null && val) {
            setLookupFieldValue(name, null)
        }

        setFirstRender(false)
    }, [firstRender, setContextFilter, getLookupFieldValue, field.value, name, setData,
        setLookupFieldValue, selectionMode, getFirstCtxValue, valueExpr])

    // callbacks for changes in lookup context
    const onNoChange = useContextSelfCallback({
        valueExpr, contextFilters: contextFilters.state, handleSelectionChanged,
        setData, loadItem, load, castToType, selectionMode
    })

    // update callbacks for fields we're interested in
    useEffect(() => {
        setCallbacks({
            [name]: onNoChange,
        })
    }, [name, onNoChange])

    const cellRendererIxERechnungArt = useIxIconCellRender({ iconsMap: (IxERechnungArtModule as any).IxERechnungArtIcons || undefined })
    const cellRenderers = useMemo(() => ([
        { name: 'cellRendererIxERechnungArt', render: cellRendererIxERechnungArt },
    ]), [
        cellRendererIxERechnungArt,
    ])

    const genLookupArray = useIxGenLookupArray()

    const columns = useMemo(() => ([
        {
            dataField: 'HDR_ID',
            dataType: 'number',
            visible: false,
            caption: t('global:field.HDR_ID'),
        },
        {
            dataField: 'NO',
            dataType: 'string',
            visible: true,
            caption: t('supplier:field.NO'),
        },
        {
            dataField: 'ANS_1',
            dataType: 'string',
            visible: true,
            caption: t('supplier:field.ANS_1'),
        },
        {
            dataField: 'ANS_2',
            dataType: 'string',
            visible: true,
            caption: t('supplier:field.ANS_2'),
        },
        {
            dataField: 'ANS_3',
            dataType: 'string',
            visible: true,
            caption: t('supplier:field.ANS_3'),
        },
        {
            dataField: 'ANS_4',
            dataType: 'string',
            visible: true,
            caption: t('supplier:field.ANS_4'),
        },
        {
            dataField: 'ANS_5',
            dataType: 'string',
            visible: true,
            caption: t('supplier:field.ANS_5'),
        },
        {
            dataField: 'TEL_1',
            dataType: 'string',
            visible: true,
            caption: t('supplier:field.TEL_1'),
        },
        {
            dataField: 'TEL_2',
            dataType: 'string',
            visible: true,
            caption: t('supplier:field.TEL_2'),
        },
        {
            dataField: 'TEL_3',
            dataType: 'string',
            visible: true,
            caption: t('supplier:field.TEL_3'),
        },
        {
            dataField: 'EMAIL',
            dataType: 'string',
            visible: true,
            caption: t('global:field.EMAIL'),
        },
    ]), [t])



    return (
        <BaseLookup
            ref={baseLookup}
            name={name}
            label={label || t('supplier:label.supplierLookup')}
            opts={data}
            readOnly={readOnly}
            valueExpr={valueExpr}
            keyExpr='HDR_ID'
            displayExpr={format}
            inputExpr={inputFormat}
            loading={loading}
            selectionMode={selectionMode}
            visible={visible}

            onInputChanged={handleInputChanged}
            onSelectionChanged={handleSelectionChanged}

            value={value}
            callbacks={callbacks}

            contextFilters={contextFilters}
            loadFn={load}
            resetFn={reset}

            columns={columns}

            openDropdown={openDropdown}
            onInfoChange={onInfoChange}

            shouldUpdate={shouldUpdateConfig}
            getFirstCtxValue={getFirstCtxValue}

            dataLoaded={dataLoaded}


            cellRenderTemplates={ cellRenderers }
        />
    )
}
